import { LoanOfferGenService } from '../services/loan-offer-gen.service';


import { CompanyOffersService } from './../../company-offers/services/company-offers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-loan-main',
  templateUrl: './home-loan-main.component.html',
  styleUrls: ['./home-loan-main.component.css']
})
export class HomeLoanMainComponent implements OnInit {

  currentUrl: string;
  
    homeloan:boolean=false;
    homeloan_bt:boolean=false;
    homeloan_tax:boolean=false;
  
    homeloan_mob:boolean=true;
    homeloanbt_mob:boolean=false;
    homeloantax_mob:boolean=false;
  
    homeloancat:boolean=true;
    reducehomeloancat:boolean=false
    homeloanTax:boolean=false;
  
    banner_data=[
      {
      title:'Best Home Loan Offers in 2 steps',
      banner_text:"Home Loan @8.25% onwards,Loan offers from 20+ banks,Nil Pre-Closure Charges"
      }
  ]
  
    constructor(
      private route: Router,
      private router:ActivatedRoute,
      private LoanOfferService:LoanOfferGenService
    ) {
      debugger 
      this.currentUrl=this.route.url;
      let n=this.currentUrl.lastIndexOf('/');
      let url= this.currentUrl.substring(n + 1);
      this.navigateBetweenOffers(url);
    }
  
    ngOnInit() {
    }
  
    showHLForm(value,link){
      this.LoanOfferService.ShowHl(value);
      this.navigateBetweenOffers(link); 
      
    }
    mobileHlForm(value,link){
     this.LoanOfferService.ShowHl(value);
      this.navigateBetweenOffersMobile(link);
    }
    showHLTForm(value,link){
      debugger
      this.homeloan_tax=true;
      this.homeloan=false;
      this.homeloan_bt=false;
      this.navigateBetweenOffers(link);
      
    }
    navigateBetweenOffers(link){
  
      if(link=='new'){
        this.homeloan=true;
        this.homeloan_bt=false;
        this.homeloan_tax=false;
  
        this.homeloan_mob=true;
        this.homeloanbt_mob=false;
        this.homeloantax_mob=false;
      }
      if(link=='transfer'){
        this.homeloan=false;
        this.homeloan_bt=true;
        this.homeloan_tax=false;
  
        this.homeloan_mob=false;
        this.homeloanbt_mob=true;
        this.homeloantax_mob=false;
      }
      if(link=='tax-savings'){
        this.homeloan=false;
        this.homeloan_bt=false;
        this.homeloan_tax=true;
        
        this.homeloanbt_mob=true;
        this.homeloan_mob=false;
        this.homeloantax_mob=true;
  
      }
      this.route.navigate([link]
        ,{ relativeTo: this.router});
      
    }
  
   navigateBetweenOffersMobile(link){
     debugger
     if(link=='new'){
      this.homeloan_mob=true;
      this.homeloanbt_mob=false;
      this.homeloantax_mob=false;
  
      this.homeloancat=true;
      this.reducehomeloancat=false;
      this.homeloanTax=false;
     }
     if(link=='transfer'){
      this.homeloan_mob=false;
      this.homeloanbt_mob=true;
      this.homeloantax_mob=false;
  
      this.reducehomeloancat=true;
      this.homeloancat=false;
      this.homeloanTax=false;
      
     }
     if(link=='tax-savings'){
       this.homeloantax_mob=true;
       this.homeloan_mob=false;
       this.homeloanbt_mob=false;
  
       this.homeloanTax=true;
       this.reducehomeloancat=false;
       this.homeloancat=false;
     }
     this.route.navigate([link]
      ,{ relativeTo: this.router});
   }
  

}



// WEBPACK FOOTER //
// ./src/app/loan/home-loan-main/home-loan-main.component.ts